import * as React from "react";
import Content from "../../../../Content";
import Axios from "../../../Components/Axios";
import {Link} from "react-router-dom";
import {Alert} from "react-bootstrap";
import Bar from "./Bar";
import Bar2 from "./Bar2";

const backendUrl = process.env.REACT_APP_BACKEND ?? '';

class Details extends React.Component {

    getKpInfo() {
        Axios
            .get(`api/kp/get/${this.state?.data?.kpId}`)
                        .then(r => this.setState({
                kpInfo: r.data
            }));
    }

    getInfo() {

        Axios.get(`api/service/${this.state.service}/info`)
                        .then(r => {
                if (r?.success) {
                    this.setState({ data: r.data ?? {} });
                    this.getKpInfo();
                } else {
                    this.setState({ error: true });
                }
            })
            .catch((e) => {
                console.log(e);
                this.props.history.push('/auth')
            });

    }

    componentDidMount() {
        this.getInfo();
    }

    constructor(props) {
        super(props);
        this.state = {
            data: {},
            error: false,
            service: this.props.match.params.service,
            kpInfo: {}
        };
    }

    render() {
        return (
            <Content title = "Информация об услуге">
                <div className="container pt-2">
                    <div className="row my-3">
                        <div className="col-12">
                            <Link to={'/admin/services'} className="btn btn-secondary mr-4">← Назад</Link>
                            {
                                !!this.state.error &&
                                <>
                                    <br/>
                                    <br/>
                                    <Alert variant={'danger'} >
                                        Ошибка при получении данных
                                    </Alert>
                                </>
                            }
                            {
                                !this.state.error &&
                                <div className="card shadow  p-2 mt-4">
                                    <div className="row  m-0">
                                        <div className="col-6 m-0 p-2">
                                            <img style={{width: '100%'}}
                                                 src={`${backendUrl}api/uploads/${(this.state.data.posterRu ?? '').split('.')[0] ?? ''}`}
                                                 alt=""/>
                                            <h5 className="mt-3"><b>Заголовок RU:</b> {this.state.data.titleRu}</h5>
                                            <h6 className="mt-1"><b>Стоимость RU:</b> {this.state.data.priceRu}</h6>
                                        </div>
                                        <div className="col-6 m-0 p-2">
                                            <img style={{width: '100%'}}
                                                 src={`${backendUrl}api/uploads/${(this.state.data.posterKg ?? '').split('.')[0] ?? ''}`}
                                                 alt=""/>
                                            <h5 className="mt-3"><b>Заголовок KG:</b> {this.state.data.titleKg}</h5>
                                            <h6 className="mt-1"><b>Стоимость KG:</b> {this.state.data.priceKg}</h6>
                                        </div>
                                    </div>
                                    <div className="row m-0 ">
                                        <div className="col-6  p-2">
                                            <h6 className="mt-0"><b>Логин:</b> {this.state.data.login}</h6>
                                        </div>
                                        <div className="col-6  p-2">
                                            <h6 className="mt-0"><b>Контент-провайдер:</b> {this.state.kpInfo?.title}
                                            </h6>
                                        </div>
                                    </div>
                                    <div className="row m-0 ">
                                        <div className="col-12  p-2">
                                            <h6 className="mt-0"><b>Обязательное СМС
                                                подтверждение:</b> {this.state.data.smsAuth ? 'Да' : 'Нет'}</h6>
                                        </div>
                                    </div>
                                    <div className="row m-0 ">
                                        <div className="col-6  p-2">
                                            <h6 className="mt-0">
                                                <b>Ссылка страницы услуги (RU):<br/></b>
                                                <a href={this.state.data.moreUrlRu} target="_blank"
                                                   rel={'noreferrer'}>{this.state.data.moreUrlRu}</a>
                                            </h6>
                                        </div>
                                        <div className="col-6  p-2">
                                            <h6 className="mt-0">
                                                <b>Ссылка страницы услуги (KG):<br/></b>
                                                <a href={this.state.data.moreUrlKg} target="_blank"
                                                   rel={'noreferrer'}>{this.state.data.moreUrlKg}</a>
                                            </h6>
                                        </div>
                                    </div>
                                    <div className="row m-0 ">
                                        <div className="col-6  p-2">
                                            <h6 className="mt-0"><b>API_URL:<br/></b> {this.state.data.apiUrl}</h6>
                                        </div>
                                        <div className="col-6  p-2">
                                            <h6 className="mt-0"><b>Соль для токена<br/></b> {this.state.data.tokenSalt}
                                            </h6>
                                        </div>
                                    </div>
                                </div>
                            }
                        </div>
                    </div>
                    <div className="row">

                        <div className="col-12">
                            <Bar
                                service = {this.state.service}
                                history = {this.props.history}
                                type = "buy"
                                title = "Подключения"
                            />
                        </div>

                        {
                            [
                                { type: 'create_id', title: 'Сессии' },
                                { type: 'url_buy', title: 'Подключения через URL' },
                                { type: 'sms_buy', title: 'Подключения через SMS' },
                                { type: 'dpi_buy', title: 'Подключения через DPI' },
                                { type: 'more_info', title: 'Просмотры информации об услуге' },
                                { type: 'create_code', title: 'Созданные SMS-коды' },
                                { type: 'code_error', title: 'Ошибка ввода SMS-кода' },
                                { type: 'timeout_error', title: 'Ошибка истечение SMS-кода' },
                                { type: 'error_msisdn', title: 'Ошибочно веденные номера' },
                            ].map(v =>
                                <div className="col-6 mt-5" key={v.type}>
                                    <Bar
                                        service = {this.state.service}
                                        history = {this.props.history}
                                        type = {v.type}
                                        title = {v.title}
                                    />
                                </div>
                            )
                        }

                        <div className="col-12 mt-5">
                            <Bar2
                                service = {this.state.service}
                                history = {this.props.history}
                                title = "Посетители по источникам"
                            />
                        </div>

                    </div>



                </div>
            </Content>
        );
    }

}

export default Details;